module.exports = __webpack_public_path__ + "img/portfolio-three-column-light.1f330d6f.png";